/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Cta_TitleInputs */

const en_cmp_cta_title = /** @type {(inputs: Cmp_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring what you've got, add the gate`)
};

const id_cmp_cta_title = /** @type {(inputs: Cmp_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bawa yang sudah ada, tambahkan gerbangnya`)
};

/**
* | output |
* | --- |
* | "Bring what you've got, add the gate" |
*
* @param {Cmp_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_cta_title = /** @type {((inputs?: Cmp_Cta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Cta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_cta_title(inputs)
	return en_cmp_cta_title(inputs)
});